<div class="flex flex-col h-screen">

  <div class="flex w-full">
    <app-report-header (dateChange)="onDateChange($event)" [getDataFunc]="getData" [exportFunc]="export"  class="w-full"></app-report-header>
  </div>

    <div class="flex-1 overflow-y-auto px-6 py-4 bg-gray-50 md:mb-32 ">
    <div class="bg-white shadow rounded overflow-x-auto">
      <p-table 
        [value]="items" 
        [paginator]="false"
        [loading]="loading"
        styleClass="p-datatable-sm"
        [rowHover]="true"
        [stripedRows]="true"
        stripedRowsClass="bg-orange-50"
        [showCurrentPageReport]="false"
        responsiveLayout="scroll"
        class="min-w-full text-sm">
        <ng-template pTemplate="header">
          <tr class="bg-gray-100">
            <th class="text-left px-6 py-3">Código</th>
            <th class="text-left px-6 py-3">Barras</th>
            <th class="text-left px-6 py-3">Description</th>
            <th class="text-left px-6 py-3">Custo</th>
            <th class="text-left px-6 py-3">Preço</th>
            <th class="text-left px-6 py-3">Quantidade</th>
            <th class="text-left px-6 py-3">Total</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item let-i="rowIndex">
          <tr [ngClass]="i % 2 === 0 ? 'bg-white' : 'bg-orange-50'">
            <td class="px-6 py-2 font-mono">{{ item.productId }}</td>
            <td class="px-6 py-2 text-red-500 font-medium">{{ item.barCode }}</td>
            <td class="px-6 py-2 font-medium">{{ item.productDescription }}</td>
            <td class="px-6 py-2 font-medium">R$ {{ item.costPrice | number: '1.2-2' }}</td>
            <td class="px-6 py-2 font-medium">R$ {{ item.price | number: '1.2-2' }}</td>
            <td class="px-6 py-2 font-medium">R$ {{ item.amount | number: '1.2-2' }}</td>
            <td class="px-6 py-2 font-medium">R$ {{ item.total | number: '1.2-2' }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6" class="text-center py-8 text-gray-500">
              Nenhum produto encontrado
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>


    <!-- Paginator -->
    <div class="flex justify-center py-4">
      <p-paginator
        [first]="first"
        [rows]="rows"
        [totalRecords]="totalRecords"
        (onPageChange)="onPageChange($event)"
        [showPageLinks]="true"
        [showFirstLastIcon]="true"
        styleClass="custom-paginator">
      </p-paginator>
    </div>

  </div>
  <div class="flex fixed bottom-0 w-full bg-white border-gray-500 px-6 py-4 items-around text-sm z-20">
  </div>


</div>
